function getDefaultMessage(status) {
  switch (status) {
    case 400:
      return 'Проверьте введённые данные.'
    case 401:
      return 'Необходимо войти в систему.'
    case 403:
      return 'У вас нет доступа к этому действию.'
    case 404:
      return 'Запрашиваемые данные не найдены.'
    case 409:
      return 'Конфликт данных.'
    case 500:
      return 'Ошибка сервера. Попробуйте позже.'
    default:
      return 'Произошла ошибка.'
  }
}

export function parseApiError(error) {
  if (!error?.response) {
    return {
      status: 0,
      message: 'Не удалось подключиться к серверу.',
      fieldErrors: {},
      raw: error
    }
  }

  const { status, data, headers } = error.response
  const retryAfterHeader = headers?.['retry-after']
  const retryAfterSeconds = Number.parseInt(retryAfterHeader, 10)
  const code = data?.code || data?.Code || null
  const fieldErrors = {}

if (data && Array.isArray(data.errors) && typeof data.title === 'string') {
    let firstBackendMessage = ''

    for (const item of data.errors) {
      if (Array.isArray(item?.errors) && item.errors.length > 0) {
        const firstMessage = item.errors.find(
          message => typeof message === 'string'
        )

        if (firstMessage) {
          firstBackendMessage ||= firstMessage

          if (item.property) {
            fieldErrors[item.property] = firstMessage
          }
        }
      }
    }

    return {
      status,
      code,
      retryAfterSeconds: Number.isFinite(retryAfterSeconds) ? retryAfterSeconds : null,
      message: firstBackendMessage || data.detail || data.title || getDefaultMessage(status),
      title: data.title,
      fieldErrors,
      raw: data
    }
  }
  
  if (data && Array.isArray(data.errors)) {
    return {
      status,
      code,
      retryAfterSeconds: Number.isFinite(retryAfterSeconds) ? retryAfterSeconds : null,
      message: data.errors[0] || getDefaultMessage(status),
      fieldErrors: {},
      raw: data
    }
  }

  if (data?.errors && typeof data.errors === 'object' && !Array.isArray(data.errors)) {
    for (const key in data.errors) {
      const messages = data.errors[key]
      if (Array.isArray(messages) && messages.length > 0) {
        fieldErrors[key] = messages[0]
      }
    }

    return {
      status,
      code,
      retryAfterSeconds: Number.isFinite(retryAfterSeconds) ? retryAfterSeconds : null,
      message: data.title || 'Ошибка валидации',
      fieldErrors,
      raw: data
    }
  }

  if (typeof data?.message === 'string') {
    return {
      status,
      code,
      retryAfterSeconds: Number.isFinite(retryAfterSeconds) ? retryAfterSeconds : null,
      message: data.message,
      fieldErrors: {},
      raw: data
    }
  }

  if (typeof data?.Message === 'string') {
    return {
      status,
      code,
      retryAfterSeconds: Number.isFinite(retryAfterSeconds) ? retryAfterSeconds : null,
      message: data.Message,
      fieldErrors: {},
      raw: data
    }
  }

  if (typeof data === 'string') {
    return {
      status,
      code,
      retryAfterSeconds: Number.isFinite(retryAfterSeconds) ? retryAfterSeconds : null,
      message: data,
      fieldErrors: {},
      raw: data
    }
  }

  return {
    status,
    code,
    retryAfterSeconds: Number.isFinite(retryAfterSeconds) ? retryAfterSeconds : null,
    message: getDefaultMessage(status),
    fieldErrors: {},
    raw: data
  }
}
